<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cent">
      <div class="cent_1">
        <div class="cent_top">
          <div class="cent_top_content">
            <img src="../../assets/img/dingdan/pay_icon_order.png" alt />
            <p>订单号：{{datas.order_sn}}</p>
          </div>
        </div>
        <div class="cent_bottom">
          <div class="cent_bottom_1">
            <ul>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step01_sel.png" alt />
                <p>沟通需求</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step02_sel.png" alt />
                <p>下单预付</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step03_sel.png" alt />
                <p>为您服务</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step04_sel.png" alt />
                <p>验收服务</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_1">
        <div class="content_one">
          <div class="content_one1">
            <p>任务详情</p>
            <p>联系商家：{{datas.phone}}</p>
          </div>
          <div class="content_one2">
            <div class="content_one2_left">
              <div class="content_one2_right1">
                <p>需求标题</p>
                <p>{{datas.service_name}}</p>
              </div>
              <div class="content_one2_right1">
                <p>任务需求</p>
                <p style="width:682px;">{{datas.remark_member}}</p>
              </div>
              <div class="content_one2_right1">
                <p>订单金额</p>
                <p style="color:#F7681E;font-weight:600;margin-right:50px;">￥{{datas.goods_price}}</p>
                <span>服务商已收</span>
                <span
                  style="color:#F7681E;font-weight:600;margin-right:50px;"
                >-￥{{datas.provider_price}}</span>
                <span>托管服务费</span>
                <span style="color:#F7681E;font-weight:600;margin-right:30px;">￥{{datas.host_price}}</span>
              </div>
            </div>
            <div class="content_one2_right">
              <div class="content_one2_right1">
                <p>需求类型</p>
                <p>{{datas.category_name}}</p>
              </div>
              <div class="content_one2_right1">
                <p>下单时间</p>
                <p>{{datas.create_time}}</p>
              </div>
              <div class="content_one2_right1">
                <p>支付时间</p>
                <p>{{datas.pay_time}}</p>
              </div>
              <div class="content_one2_right1">
                <p>结束时间</p>
                <p>{{datas.finish_time}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content_two">
          <div class="content_botom_1">
            <el-button type="primary" class="bot" @click="dialogVisible3 = true">开发票</el-button>
            <el-button
              type="primary"
              class="bot"
              @click="dialogVisible2 = true"
              v-if="datas.is_comment == 0"
            >评价</el-button>
          </div>
        </div>
        <div class="content_tree" v-if="datas.is_comment == 1">
          <p class="content_tree_P">我的评价</p>
          <div class="content_tree1">
            <div class="content_tree1_one">
              <ul>
                <li>
                  <p>完成质量</p>
                  <div class="block">
                    <el-rate v-model="datas.reply_grade"></el-rate>
                  </div>
                </li>
                <li>
                  <p>完成速度</p>
                  <div class="block">
                    <el-rate v-model="datas.reply_grade"></el-rate>
                  </div>
                </li>
                <li>
                  <p>服务态度</p>
                  <div class="block">
                    <el-rate v-model="datas.reply_grade"></el-rate>
                  </div>
                </li>
              </ul>
            </div>
            <p class="content_tree1_onep">{{datas.reply_content}}</p>
          </div>
        </div>
        <div class="content_four" v-if="orderD != ''">
          <div class="content_four_1">
            <p class="content_four_1_1">服务费记录</p>
            <p class="content_four_1_2">
              订单金额&nbsp;&nbsp;&nbsp;
              <span style="color:#F7681E;">￥{{orderD.goods_price}}</span>
            </p>
            <p class="content_four_1_2">
              服务商已收
              <span style="color:#F7681E;">-￥{{orderD.provider_price}}</span>
            </p>
            <p class="content_four_1_2">
              托管服务费
              <span style="color:#F7681E;">￥{{orderD.host_price}}</span>
            </p>
          </div>
          <div class="content_four_2">
            <div class="content_four_one">
              <div
                class="content_four_one1"
                v-for="(item,index) in orderD.service_log"
                :key="index"
              >
                <ul>
                  <li>{{item.update_time}}</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">追加服务费￥{{item.edit_price}}</p>
                    <!-- <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>-->
                  </li>
                </ul>
              </div>
              <!-- <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">已验收￥500.00</p>
                    <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>
                  </li>
                </ul>
              </div>
              <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">已验收￥500.00</p>
                    <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>
                  </li>
                </ul>
              </div>
              <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">已验收￥500.00</p>
                    <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>
                    <p class="four_one_P1">拒绝理由：第一阶段内容还未完成，请贵公司与我方沟通以便及时改正</p>
                  </li>
                </ul>
              </div>
              <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">首次托管服务费￥500.00</p>
                  </li>
                </ul>
              </div>-->
              <!-- <div class="kong"></div> -->
            </div>
          </div>
        </div>

        <div class="content_four">
          <div class="content_four_1">
            <p class="content_four_1_1">需求记录</p>
            <p
              class="content_four_1_1p"
              v-for="(item,index) in getorder"
              :key="index"
            >{{item.remark_member}}</p>
          </div>
          <div class="content_four_2">
            <div class="content_four_one">
              <div class="content_four_one1" v-for="(item,index) in getorder" :key="index">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">补充需求</p>
                    <p class="four_one_P1">{{item.remark_member}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
    <el-dialog title :visible.sync="dialogVisible2" width="660px" height="443px">
      <div class="acceptance">
        <div class="acceptance_top">
          <p>评价</p>
        </div>
        <div class="pingjia">
          <div class="acceptance_top_1">
            <p>完成质量</p>
            <div class="block">
              <el-rate v-model="form.service_quality"></el-rate>
            </div>
          </div>

          <div class="acceptance_top_1">
            <p>完成速度</p>
            <div class="block">
              <el-rate v-model="form.service_speed"></el-rate>
            </div>
          </div>

          <div class="acceptance_top_1">
            <p>服务态度</p>
            <div class="block">
              <el-rate v-model="form.service_attitude"></el-rate>
            </div>
          </div>
        </div>
        <div class="acceptance_cent">
          <p>
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请对本次服务进行评价"
              class="in"
              v-model="form.content"
            ></el-input>
          </p>
        </div>
        <div class="acceptance_floor">
          <el-button type="primary" class="botton" @click="needs(datas.id)">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible3" width="50%">
      <div class="dialog">
        <img src="../../assets/img/geren/pop_QR.png" alt />
        <p>请前往小程序进行操作</p>
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderInfo,
  createorderReply,
  orderDetails,
  orderRemarkAdd
} from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      datas: [],
      dialogVisible2: false,
      dialogVisible3:false,
      form: {
        service_quality: null,
        service_speed: null,
        service_attitude: null,
        content: ""
      },
      orderD: [],
      getorder: []
    };
  },
  methods: {
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    table(index) {
      this.numm = index;
    },
    getorderInfo(id) {
      this.token = localStorage.getItem("token");
      getOrderInfo({
        order_id: id,
        token: this.token
      }).then(res => {
        this.datas = res.data.data;
        console.log(this.datas);
      });
    },
    needs(id) {
      this.token = localStorage.getItem("token");
      createorderReply({
        token: this.token,
        order_id: id,
        goods_id: this.datas.goods_id,
        service_quality: this.form.service_quality,
        service_speed: this.form.service_speed,
        service_attitude: this.form.service_attitude,
        content: this.form.content
      }).then(res => {
        this.dialogVisible2 = false;

        this.getorderInfo(id);
      });
    },
    orderdetails(id) {
      this.token = localStorage.getItem("token");
      orderDetails({
        token: this.token,
        order_id: id
      }).then(res => {
        this.orderD = res.data.data;
      });
    },
    getorderRemarkAdd() {
      this.token = localStorage.getItem("token");
      var id = this.$route.query.id;
      orderRemarkAdd({
        token: this.token,
        order_id: id
      }).then(res => {
        this.getorder = res.data.data;
        console.log(this.getorder);
      });
    }
  },
  created() {
    var id = this.$route.query.id;
    this.getorderInfo(id);
    this.orderdetails(id);
    this.getorderRemarkAdd();
    this.$emit("header", true); //是否显示头部
  }
};
</script>

<style scoped>
@import "../../components/style.css";
.dialog {
  width: 28%;
  height: auto;
  margin: 30px auto;
  text-align: center;
}

.dialog img{
  margin: 30px 0 0 0;
}

.dialog p {
  text-align: center;
  margin: 20px 0;
  font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.cent {
  width: 100%;
  background: #007bff;
}

.cent_1 {
  width: 1200px;
  height: 200px;
  margin: 0 auto;
}

.cent_top {
  width: 100%;
  height: 100px;
  overflow: hidden;
}

.cent_top_content {
  width: 300px;
  height: 62px;
  margin: 20px auto;
}

.cent_top_content img {
  float: left;
  padding: 8px 0;
}

.cent_top_content p {
  line-height: 60px;
  color: #ffffff;
}

.cent_bottom {
  width: 100%;
  height: 100px;
  background: #f4f5f9;
  overflow: hidden;
}

.cent_bottom_1 {
  width: 500px;
  height: 66px;
  margin: 18px auto;
}

.cent_bottom_1 ul li {
  float: left;
  padding: 0 15px;
}

.cent_bottom_1 ul li p {
  font-size: 12px;
  font-weight: 400;
}

.cent_bottom_1 ul li i {
  line-height: 66px;
  font-weight: 600;
}

.content {
  width: 100%;
  height: 1249px;
  background: #f4f5f9;
}

.content_1 {
  width: 1200px;
  margin: 0 auto;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.content_one {
  width: 100%;
  height: 252px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 7px 0px rgba(244, 245, 249, 1);
}

.content_one1 {
  width: 100%;
  height: 50px;
  margin-bottom: 33px;
}

.content_one1 p:first-child {
  float: left;
  padding: 0 20px;
  border-left: 5px solid #007bff;
  margin-top: 24px;
  font-size: 20px;
  font-weight: 600;
}

.content_one1 p:last-child {
  float: right;
  width: 187px;
  height: 36px;
  background: rgba(0, 123, 255, 1);
  border-radius: 18px 0px 0px 18px;
  margin-top: 24px;
  color: #fff;
  opacity: 0.5;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
}

.content_one2 {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.content_one2_right {
  width: 300px;
  height: 86px;
  border-left: 1px dotted #e4e4e4;
  float: right;
}

.content_one2_right1 {
  width: 100%;
  height: 35px;
}

.content_one2_right1 p {
  float: left;
  font-size: 14px;
  margin-bottom: 10px;
}

.content_one2_right1 p:first-child {
  padding: 0 30px;
  color: #999999;
}

.content_one2_left {
  width: 800px;
  height: 190px;
  float: left;
}

.content_one2_right1 span {
  font-size: 14px;
  color: #999999;
}

.fuwudaoqi {
  width: 681px;
  height: 44px;
  background: rgba(255, 228, 227, 1);
  border-radius: 0px 22px 22px 22px;
  overflow: hidden;
  float: right;
  margin-top: 10px;
}

.fuwudaoqi p {
  font-size: 14px;
  color: #ff4d43;
  text-align: center;
  line-height: 44px;
}

.content_two {
  width: 100%;
  height: 60px;
  background: #fff;
  margin-bottom: 31px;
}

.content_botom_1 {
  float: right;
  margin-right: 40px;
}

.bot {
  width: 100px;
  height: 30px;
  background: #f4f5f9;
  outline: 0;
  border: 0;
  color: #222222;
  font-size: 12px;
  margin: 8px 0 0 0;
}

.bot:hover {
  background: #007bff;
  color: #fff;
}

.content_tree {
  width: 100%;
  height: auto;
  background: #fff;
  overflow: hidden;
  margin-bottom: 30px;
}

.content_tree_P {
  font-size: 20px;
  font-weight: 600;
  padding: 0 30px;
  border-left: 5px solid #007bff;
  margin: 30px 0;
}

.content_tree1 {
  width: 100%;
  height: 118px;
}

.content_tree1 p img {
  padding: 10px 0;
}

.content_four_1_1 {
  font-size: 20px;
  font-weight: 600;
  padding: 0 30px;
  border-left: 5px solid #007bff;
  margin: 30px 0;
}

.bott {
  float: right;
  width: 180px;
  height: 44px;
  background: #e4e4e4;
  outline: 0;
  border: 0;
  color: #222222;
  font-size: 12px;
  margin: 18px 40px;
  color: #fff;
}

.content_four {
  width: 100%;
  height: 300px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 30px;
}

.content_four_1 {
  width: 320px;
  height: 719px;
  border-right: 1px solid #e4e4e4;
  overflow: hidden;
  float: left;
}
.content_four_1_2 {
  padding: 0 30px;
  font-size: 14px;
  line-height: 30px;
  color: #999;
}

.content_four_1_2 span {
  padding: 0 30px;
}

.content_four_2 {
  width: 879px;
  height: 300px;
  float: left;
  position: relative;
  overflow: scroll;
}

.content_four_one {
  width: 100%;
  height: auto;
  margin: 34px 0 0 0;
  overflow: hidden;
}

.content_four_one1 {
  overflow: hidden;
}

.content_four_one1 ul li {
  float: left;
  margin: 0 20px;
  margin-bottom: 15px;
}

.content_four_one1 ul li:nth-child(1) {
  width: 72px;
}
.content_four_one1 ul li:nth-child(2) {
  width: 8px;
  height: 8px;
  background: rgba(0, 123, 255, 1);
  border-radius: 50%;
  line-height: 20px;
  margin-top: 10px;
  z-index: 1;
}

.four_one_P {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

.four_one_P1 {
  width: 660px;
  font-size: 14px;
  color: #666666;
  margin-bottom: 10px;
}

.four_img {
  width: 80px;
  height: 80px;
  background: #000;
  margin-bottom: 10px;
}
.kong {
  width: 0;
  height: 600px;
  border: 1px solid #e4e4e4;
  position: absolute;
  top: 47px;
  left: 135px;
}

.content_four_1_1p {
  width: 261px;
  height: 135px;
  margin: 0 auto;
  font-size: 14px;
}

.content_tree1_one {
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
}

.content_tree1_one ul li p {
  font-size: 14px;
  color: #999;
  float: left;
  line-height: 30px;
  padding: 0 30px;
  margin-left: 20px;
}

.content_tree1_one ul li {
  float: left;
}

.content_tree1_onep {
  width: 1131px;
  height: 55px;
  margin: 0 auto;
  font-size: 14px;
}

.acceptance {
  width: 660px;
  height: 520px;
  background: #fff;
  border-radius: 15px;
}

.acceptance_top {
  width: 100%;
  height: 60px;
  background: #f4f5f9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.acceptance_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
  text-align: center;
  line-height: 60px;
}

.acceptance_cent {
  width: 580px;
  height: 250px;
  margin: 20px auto;
}

.acceptance_cent p:first-child {
  float: left;
  padding: 10px 20px 0 0;
}

.acceptance_cent .in {
  width: 580px;
  height: 209px;
  padding: 10px 0 0 0;
}

.acceptance_floor {
  width: 180px;
  height: 44px;
  margin: 0 auto;
}

.botton {
  width: 180px;
  height: 44px;
  margin-bottom: 20px;
}

.acceptance_top_1 {
  width: 220px;
  padding: 10px 0 0 30px;
  float: left;
}

.acceptance_top_1 p {
  float: left;
  padding: 0 15px;
}
.pingjia {
  width: 100%;
  height: 50px;
}

.block {
  float: left;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/Dingdan/Wangjie.vue